const ferries = {
  ferry: "Veerboot", // translated
  ferries: "Veerboten", // translated
  selectOriginPort: "Selecteer de oorsprongspoort", // translated
  selectDestPort: "Selecteer de bestemmingspoort", // translated
  continue: "Doorgaan", // translated
  viewTimetables: "Bekijk dienstregelingen", // translated
  operator: "Exploitant", // translated
  cabin: "Cabine", // translated
  cabins: "Hutten", // translated
  place: "Plaats", // translated
  places: "Plaatsen", // translated
  seat: "Zitplaats", // translated
  seats: "Zitplaatsen", // translated
  seating: "Zitplaatsen", // translated
  deckSpace: "Dekruimte", // translated
  compulsory: "verplicht", // translated
  departure: "Vertrek", // translated
  total: "Totaal", // translated
  back: "Rug", // translated
  next: "Volgende", // translated
  duration: "Duur", // translated
  return: "Opbrengst", // translated
  prebook: "Voorboeking", // translated
  travelInfo: "Reisinformatie", // translated
  book: "Boek", // translated
  adults: "Volwassenen", // translated
  child: "Kind", // translated
  seniors: "Senioren", // translated
  senior: "Senior", // translated
  to: "naar", // translated
  passenger: "Passagier", // translated
  details: "Details", // translated
  currencyForTickets: "De valuta voor deze tickets is", // translated
  seatsError: "Het aantal passagiers is niet gelijk aan de capaciteit.", // translated
  title: "Titel", // translated
  firstName: "Voornaam", // translated
  lastName: "Achternaam", // translated
  email: "E-mail", // translated
  phone: "Telefoon", // translated
  dateOfBirth: "Geboortedatum", // translated
  placeOfBirth: "Geboorteplaats", // translated
  groupLeader: "Groepsleider", // translated
  isRequired: "Is benodigd", // translated
  charactersOnly: "Alleen karakters", // translated
  latinCharactersAndSpacesOnly: "Alleen Latijnse tekens en spaties", // translated
  validEmail: "Geen geldig e-mailadres", // translated
  atLeastOneAdult: "Er is minimaal 1 volwassene vereist.", // translated
  atLeastOneSenior: "Er is minimaal 1 senior vereist.", // translated
  toastAlert: "Corrigeer alle fouten in de onderstaande formulieren.", // translated
  backToFerriesList: "Terug naar de lijst met veerboten", // translated
  bestPrice: "Beste prijs", // translated
  fastest: "Snelste", // translated
  beforeDeparture: "Vóór het vertrek", // translated
  perPerson: "per persoon", // translated
  notAvailableForOnlineBooking: "Niet beschikbaar voor online boeking", // translated
  hurryLimitedAvailability: "Haast je! Gelimiteerde beschikbaarheid", // translated
  berth: "Ligplaats", // translated
  berths: "Ligplaatsen", // translated
  sumOfSelectionNotEqualToPersons: "De som van uw selectie is niet gelijk aan het aantal passagiers", // translated
  attemptToBook: "U heeft geprobeerd een totaal van te boeken", // translated
  seatsWhenYouHave: "zitplaatsen als je dat hebt", // translated
  passengersTravelling: "reizende passagiers", // translated
  withReturn: "met retourtickets", // translated
  pleaseCorrectYourSelection: "Corrigeer uw selectie", // translated
  pleaseSelectUpTo: "Selecteer maximaal", // translated
  accommodationTypes: "soorten accommodatie", // translated
  selectionPrices: "Selectie Prijzen", // translated
  yourCurrentTicket: "Uw huidige tickettype is", // translated
  upgradeTo: "Upgraden naar", // translated
  wouldYouLikeToUpgrade: "Wilt u uw tickettype upgraden?", // translated
  backToTicketTypes: "Terug naar Tickettypen", // translated
  originPort: "Herkomst poort", // translated
  destinationPort: "Haven van bestemming", // translated
  outboundDate: "Uitgaande datum", // translated
  inboundDate: "Inkomende datum", // translated
  passengers: "Passagiers", // translated
  hasReturn: "Heeft terugkeer", // translated
  passportNumber: "Paspoortnummer", // translated
  passportExpiryDate: "Paspoort vervaldatum", // translated
  passportPlaceOfIssue: "Uitgifteplaats van paspoort", // translated
  passportStartDate: "Begindatum paspoort", // translated
  cityCode: "Stadscode", // translated
};

export default ferries;
